import { AppointmentType } from '@uplift/api';


export const lateFeeAmountByAppointmentType: Record<AppointmentType, number> = {
  [AppointmentType.therapy]: 8500,
  [AppointmentType.psychiatry]: 13000,
};
